{
  "nav": {
    "home": "Home",
    "session": "Session",
    "about": "About"
  },
  "topbar": {
    "toggleNavigation": "Toggle navigation",
    "search": "Search",
    "openAiChat": "Open AI chat",
    "switchToEnglish": "Switch to English",
    "switchToSpanish": "Switch to Spanish",
    "logOut": "Log out",
    "copyRoom": "Copy room",
    "copied": "Copied"
  },
  "sidenav": {
    "userSubtitle": "future-room user"
  },
  "aiChat": {
    "label": "AI chat",
    "comingSoon": "AI chat coming soon"
  },
  "home": {
    "heading": "Room of the Future",
    "paragraph1": "future-room is the new home for Presence Learning's therapy room. The session opens in a Lessonspace Space.",
    "paragraph2": "Every piece you see here, from the navigation to the theme, is built on our shared component library so the app looks and behaves consistently with the rest of the Presence platform from day one.",
    "paragraph3": "This is still early - most of what will eventually live here hasn't been built yet. Check back as more of the experience moves over."
  },
  "door": {
    "providerHeading": "Session",
    "providerIntro": "Open the classroom, then copy the room link. Students use that link and wait in the Lessonspace waiting room.",
    "openClassroom": "Open classroom",
    "loadingSchedule": "Loading the schedule.",
    "noAppointment": "No appointment is on the schedule.",
    "startAdhoc": "Start ad hoc meeting",
    "adhocHeading": "Ad hoc meeting",
    "untitledAppointment": "Appointment",
    "notStarted": "This appointment has not started yet. You can still open its classroom.",
    "clientsHeading": "Clients",
    "doorDown": "The local Lessonspace door is not running. Start it with npm run lessonspace:door.",
    "studentHeading": "Join the session",
    "yourName": "Your name",
    "join": "Join",
    "joining": "Joining the room.",
    "missingRoom": "This room link is not valid.",
    "scheduleFailed": "The schedule could not be loaded.",
    "launchFailed": "The classroom could not be opened.",
    "joinFailed": "The room could not be opened. Is the local door running?",
    "openGif": "Open GIF",
    "closeOverlay": "Close",
    "overlayTitle": "Sample resource",
    "overlayImage": "Dancing grandma"
  },
  "loggedOut": {
    "heading": "You have been logged out",
    "body": "Your session has ended. Log in again to continue where you left off.",
    "return": "Return to login"
  },
  "about": {
    "heading": "About",
    "paragraph1": "This project exists to give Presence Learning's engineering team a modern, well-tested foundation to build on, instead of continuing to extend an aging codebase that's grown harder to change safely over time.",
    "paragraph2": "We're prioritizing accessibility, performance, and observability from the very first commit, so the quality bar for every new screen is set before the screen itself exists.",
    "paragraph3": "The migration will happen incrementally, one portal and one workflow at a time, so users experience a steady stream of improvements rather than one large, risky cutover."
  }
}
